import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService, IndividualConfig } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(private toastr: ToastrService, private router: Router) {}

  success(message: string, title = 'Success') {
    this.toastr.success(message, title);
  }

  error(message: string, title = 'Error') {
    this.toastr.error(message, title);
  }

  info(message: string, title = 'Info') {
    this.toastr.info(message, title);
  }

  warning(message: string, title = 'Warning') {
    this.toastr.warning(message, title);
  }

  showInfoWithLink(message: string, linkUrl: string, title?: string) {
    const htmlMessage = `${message} <a href="${linkUrl}" target="_blank" style="color:#fff; text-decoration: underline;">Open Link</a>`;
    
    const options: Partial<IndividualConfig> = {
      enableHtml: true,
      closeButton: true,
      timeOut: 5000
    };

    this.toastr.info(htmlMessage, title ?? 'Info', options);
  }

  showSuccessWithLink(message: string, linkTitle: string, route: string, title?: string) {
    const htmlMessage = `${message} <a href="javascript:void(0);" (click)="navigateTo('${route}')" style="color:#fff; text-decoration: underline;">${linkTitle}</a>`;

    const options = {
      enableHtml: true,
      closeButton: true,
      timeOut: 50000
    };

    this.toastr.success(htmlMessage, title ?? 'Success', options);
  }

  // Optionally allow passing config
  custom(message: string, title: string, type: 'success' | 'error' | 'info' | 'warning', config?: Partial<{}>) {
    switch (type) {
      case 'success': return this.toastr.success(message, title, config);
      case 'error': return this.toastr.error(message, title, config);
      case 'info': return this.toastr.info(message, title, config);
      case 'warning': return this.toastr.warning(message, title, config);
    }
  }

  navigateTo(route: string) {

    console.log(route)
    this.router.navigateByUrl(route);
  }
}
